import { IProductGalleryBlock } from '@features/cms/typescript';
import { IParsedImage } from '@components/typescript';
import styles from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlock.styles';
import ProductGalleryBlockContent from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockContent/ProductGalleryBlockContent';
type PropsType = {
  data: IProductGalleryBlock<IParsedImage>;
  isFirst?: boolean;
};
const ProductGalleryBlock = ({
  data,
  isFirst = false
}: PropsType) => <section id={data.code} sx={styles.section} data-testid={data.code}>
    <ProductGalleryBlockContent data={data} isFirst={isFirst} />
  </section>;
export default ProductGalleryBlock;